export default __webpack_public_path__ + "static/media/mheaderRes-min.52eaa713.jpg";